import type { SmsThreadAnchor } from '../dashboard/SmsThreadModal';
import type { FlowThread } from '../../../hooks/graphql/flows/useFlowActivityGQL';

/**
 * Where the Activity panel finds an SMS thread's newest message: by its
 * conversation, or — for a text sent outside any conversation — by the
 * message itself (its thread id is the message id).
 */
export function flowSmsLookup(thread: Pick<FlowThread, 'threadId' | 'conversationId'>): {
  conversationId?: string;
  messageId?: string;
} {
  return thread.conversationId
    ? { conversationId: thread.conversationId }
    : { messageId: thread.threadId };
}

/**
 * The SMS view's anchor, built from the stored message itself. The view
 * renders the anchor's body as-is and pages older/newer messages around it,
 * so it must be the full text — never the Activity table's trimmed preview.
 */
export function flowSmsAnchor(message: {
  messageId: string;
  body: string | null;
  direction: string | null;
  sentAt: string | null;
  createdAt: string | null;
}): SmsThreadAnchor {
  return {
    messageId: message.messageId,
    body: message.body,
    direction: message.direction,
    sentAt: message.sentAt,
    createdAt: message.createdAt,
  };
}
